
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[id]/projecten/[projectId]",
      function () {
        return require("private-next-pages/users/[id]/projecten/[projectId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/[id]/projecten/[projectId]"])
      });
    }
  